/*
 * Overgang bij het aanklikken van een merk of model.
 *
 * De rij zakt weg en de aangeklikte markering blijft staan terwijl de
 * collectie laadt. Eén beweging van 180ms op elementen die er al zijn — geen
 * laadscherm, want dat is er bewust uit gehaald.
 *
 * Wat het bewust niet doet:
 *
 * - Een klik met ctrl, cmd, shift of de middelste knop laat het met rust.
 *   Die opent een nieuw tabblad; daar hoort de huidige pagina niet op te
 *   reageren.
 * - Bij prefers-reduced-motion gebeurt er niets en gaat de link gewoon door.
 * - Duurt het laden langer dan de animatie, dan blijft de rij weggezakt tot de
 *   nieuwe pagina komt. Blijft het hangen, dan zet pageshow alles terug —
 *   anders kijk je na een terugknop naar een half verdwenen rij.
 */

(() => {
  const DUUR = 180;

  const RIJEN = [
    { lijst: '.subcollection-nav__list', item: '.subcollection-nav__item' },
    { lijst: '.model-navigation', item: '.model-navigation__item' },
    { lijst: '.merkrail', item: '.merkrail__item' },
  ];

  const minderBeweging = window.matchMedia('(prefers-reduced-motion: reduce)');

  const gewoneKlik = (e) =>
    e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;

  const herstel = () => {
    document.querySelectorAll('.nav-transition--bezig').forEach((l) => {
      l.classList.remove('nav-transition--bezig');
    });
    document.querySelectorAll('.nav-transition--gekozen').forEach((i) => {
      i.classList.remove('nav-transition--gekozen');
    });
  };

  const koppel = ({ lijst, item }) => {
    document.querySelectorAll(lijst).forEach((rij) => {
      if (rij.dataset.navTransitie === '1') return;
      rij.dataset.navTransitie = '1';

      rij.addEventListener('click', (e) => {
        if (minderBeweging.matches || !gewoneKlik(e)) return;

        const gekozen = e.target.closest(item);
        if (!gekozen || !rij.contains(gekozen)) return;

        const link = gekozen.matches('a') ? gekozen : gekozen.querySelector('a');
        if (!link || !link.href || link.target === '_blank') return;

        e.preventDefault();

        rij.classList.add('nav-transition--bezig');
        gekozen.classList.add('nav-transition--gekozen');

        setTimeout(() => {
          window.location.href = link.href;
        }, DUUR);
      });
    });
  };

  /*
   * De markering van de collectie waar je bent in beeld schuiven.
   *
   * Op een telefoon is de rij breder dan het scherm. Sta je op Jordan 1 Mid,
   * dan staat die markering buiten beeld en zie je alleen de eerste twee --
   * de rij vertelt je dan niets over waar je bent. Hij komt hier zo in beeld
   * dat je de buren links en rechts meeziet, want dat is wat een rij doet:
   * laten zien wat er nog meer is.
   *
   * Alleen als hij er echt buiten valt. Staat hij al in beeld, dan is
   * verschuiven onnodige beweging op een pagina die net geladen is.
   *
   * scrollLeft direct en geen scrollIntoView: die laatste schuift ook alle
   * ouders mee, en dan springt de pagina bij het laden naar de rij toe.
   */
  const naarGekozen = () => {
    document.querySelectorAll('.model-navigation__list, .subcollection-nav__list').forEach((rij) => {
      if (rij.scrollWidth <= rij.clientWidth) return;

      const gekozen = rij.querySelector('.is-active, [aria-current="page"]');
      if (!gekozen) return;

      const g = gekozen.getBoundingClientRect();
      const r = rij.getBoundingClientRect();
      if (g.left >= r.left && g.right <= r.right) return;

      rij.scrollLeft += g.left - r.left - (r.width - g.width) / 2;
    });
  };

  const init = () => {
    RIJEN.forEach(koppel);
    naarGekozen();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  // Terugknop uit de geschiedenis: de pagina komt uit de cache met de klassen
  // er nog op, dus die moeten eraf.
  window.addEventListener('pageshow', herstel);
})();
